import { useTranslation } from '@lyearn/i18n';
import { CircleDashed } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { BaseButton, Typography } from '@lyearn/ui';
import { StageConfigSchema } from '@/types/schema';
import { svgSizeStyles } from '@/utils/styles';

import ProjectStageMenu from '../../features/actionItems/components/ActionStage/ProjectStageMenu';
import {
  baseButtonFocusStyles,
  TASK_PILL_VARIANT_CONFIG,
  TaskPillVariant,
} from '../TaskStatus/styles';

interface Props {
  stageId?: string | null;
  projectId?: string;
  className?: string;
  editable?: boolean;
  onChange: (stageId?: string) => void;
  variant: TaskPillVariant;
  stageInfo?: Pick<StageConfigSchema, 'stageId' | 'name' | 'iconSettings'> | null;
  placeholder?: string;
}

const TaskStage = (props: Props) => {
  const { className, variant, editable, stageId, projectId, onChange, placeholder } = props;
  const { t } = useTranslation(['Task']);

  const variantConfig = TASK_PILL_VARIANT_CONFIG[variant];

  if (editable) {
    return (
      <ProjectStageMenu
        disabled={!projectId}
        projectId={projectId}
        stageId={stageId ?? undefined}
        onStageChange={onChange}>
        {({ selectedOptions }) => {
          const selectedStage = selectedOptions[0];
          return (
            <BaseButton
              aria-label="stage"
              className={cn(
                'h-32 w-max p-0 gap-8',
                baseButtonFocusStyles,
                svgSizeStyles(2),
                variantConfig.root.className,
                className,
                { [variantConfig.rootEditable.className]: editable },
              )}
              disabled={!editable}>
              {selectedStage?.Icon ? (
                <selectedStage.Icon className="shrink-0" />
              ) : (
                <CircleDashed fillColorToken="icon-placeholder" />
              )}
              <Typography
                className={variantConfig.label.className}
                color={variantConfig.label.color}
                variant="body-short-02">
                {selectedStage?.label ?? placeholder ?? t('Common:Filter.None')}
              </Typography>
            </BaseButton>
          );
        }}
      </ProjectStageMenu>
    );
  }
};

export default TaskStage;
